"use strict";

require("core-js/modules/es6.date.now");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var console_transport_1 = __importDefault(require("./console-transport"));

var TimeManager =
/** @class */
function () {
  function TimeManager() {
    this.timeLabels = {};
  }

  TimeManager.prototype.time = function (label) {
    if (this.timeLabels[label]) {
      // console.warn(`[error] duplicate label [${label}]`)
      console_transport_1["default"]('warn', '', "[warn] duplicate label '" + label + "'");
      return;
    }

    this.timeLabels[label] = Date.now();
  };

  TimeManager.prototype.timeEnd = function (label) {
    var asisTime = this.timeLabels[label];

    if (!asisTime) {
      // console.warn(`[error] Not found label [${label}]`)
      console_transport_1["default"]('warn', '', "[warn] Not found label '" + label + "'");
      return;
    }

    this.timeLabels[label] = undefined;
    return Date.now() - asisTime;
  };

  return TimeManager;
}();

exports["default"] = TimeManager;